<template>
    <b-overlay :show="loading" class="animated">
        <v-server-table
            :columns="table_config.columns"
            :options="table_config.options"
            :theme="theme"
            :ref="ref"
            id="managed-list-attributes-server-table"
            class="w-100"
        >
            <span slot="name" slot-scope="{ row }">
                <a :href="`#/attributes-lists/${row.id}`" class="btn-link">
                    {{ row.value }}
                </a>
            </span>
            <span slot="sub_attributes" slot-scope="{ row }">
                {{ row.children.length || "--" }}
            </span>
        </v-server-table>
    </b-overlay>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import BaseServerTable from "@/components/shared/BaseServerTable";

Vue.use(ServerTable);

export default {
    name: "ManagedListAttributesServerTable",
    extends: BaseServerTable,
    components: {
        ServerTable,
    },
    props: {
        collection: {
            default: () => null,
        },
        sortable: {
            type: Array,
            default: () => ["name"]
        },
        filterable: {
            type: Array,
            default: () => ["searchable"]
        },
        skip_filter_reset: {
            type: Boolean,
            default: true,
        },
        show_columns: {
            type: Array,
            default: () => ["name", "sub_attributes", "actions"]
        },
    },
    data() {
        return {
            table_config: Object.assign(this.getDefaultTableConfig(), {
                options: {
                    headers: {
                        value: "Name",
                        sub_attributes: "Sub - Attributes",
                        actions: "Actions"
                    },
                    filterable: this.filterable,
                    sortable: this.sortable
                }
            })
        };
    },
};
</script>